import axiosCall from './interceptor';
import URL from '../helper';

export const createTemplate = async data => {
  const url = `${URL.BASE_URL}message`;
  let response = await axiosCall('post', url, data, false);
  return response.data;
};

export const updateTemplate = async (data, type) => {
  const url = `${URL.BASE_URL}message/${type}`;
  let response = await axiosCall('patch', url, data);
  return response.data;
};

export const getTemplate = async templateId => {
  let url = `${URL.BASE_URL}message?id=${templateId}`;
  let response = await axiosCall('get', url);
  return response.data;
};

export const getTemplateByGroup = async groupId => {
  let url = `${URL.BASE_URL}message?groupid=${groupId}`;
  let response = await axiosCall('get', url);
  return response.data;
};

export const translateTemplate = async payload => {
  const { id, language } = payload;
  const url = `${URL.BASE_URL}message/translate?id=${id}&language=${language}`;
  let response = await axiosCall('post', url, '');
  return response.data;
};

export const getAllTemplates = async (categoryId, type, searchVal, searchTag, page, selectedLanguage) => {
  let payload = {
    page,
    messageType: type,
    ...( selectedLanguage && selectedLanguage !== 'all' && { language: selectedLanguage }), 
  };
  if (categoryId) {
    payload.categoryIds = categoryId;
  }
  if (searchVal) {
    payload.name = searchVal;
  }
  if (searchTag) {
    payload.tags = searchTag;
  }
  const searchParam = new URLSearchParams(payload);
  const url = `${URL.BASE_URL}message?limit=8&${searchParam.toString()}`;
  let response = await axiosCall('get', url);
  return response.data;
};

export const updateCommunicationName = async (id, communicationName) => {
  const url = `${URL.DESIGN_SYSTEM_URL}channel/map?id=${id}&communicationName=${encodeURIComponent(communicationName)}`;
  let response = await axiosCall('post', url);
  return response.data;
}

export const searchTemplates = async (payload, type, isPublished = false) => {
  const params = new URLSearchParams(payload);
  const statusUrl = isPublished ? 'publishedmessage' : 'messagebycategory';
  let url = `${URL.BASE_URL}${statusUrl}?includePages=true&includeVariables=true&${params}`;
  if (type) {
    url = `${URL.BASE_URL}${statusUrl}?includePages=true&includeVariables=true&type=${type}&${params}`;
  }
  if (isPublished) {
    url = `${url}&rgpermission=write`;
  }
  let response = await axiosCall('get', url);
  return response.data;
};

export const deleteShortMessageTemplate = async payload => {
  const url = `${URL.BASE_URL}message?id=${payload.id}`;
  let response = await axiosCall('delete', url);
  return response.data;
};

export const moveToQaReady = async (id, checkedList) => {
  let list = checkedList.join(',');
  const url = `${URL.BASE_URL}message/movetoqaready?messageType=${list}&id=${id}`;
  let response = await axiosCall('post', url);
  let finalResponse = response.data.statusCode;
  return finalResponse;
};

export const getVoicesTemplate = async payload => {
  const params = new URLSearchParams(payload);
  const url = `${URL.BASE_URL}message/voices?${params}`;
  const response = await axiosCall('get', url);
  return response.data;
};

export const getAudio = async payload => {
  const params = new URLSearchParams(payload);
  const url = `${URL.BASE_URL}message/audio?${params}`;
  const response = await axiosCall('get', url);
  return `${URL.BASE_URL}message/audio?${params}`;
};

export const sendTestMessage = async (li, payload) => {
  const url = `${URL.BASE_URL}message/draft/${li}`;
  let response = await axiosCall('post', url, payload);
  return response.data;
};

export const sendQAReadyTestMsg = async (li, payload) => {
  const url = `${URL.BASE_URL}message/sandbox/${li}`;
  let response = await axiosCall('post', url, payload);
  return response.data;
};

export const sendPublishedTestMsg = async (li, payload) => {
  const url = `${URL.BASE_URL}message/live/${li}`;
  let response = await axiosCall('post', url, payload);
  return response.data;
};

export const getTestingVersions = async id => {
  const url = `${URL.BASE_URL}qareadymessage?messageId=${id}`;
  const response = await axiosCall('get', url);
  return response.data;
};

export const getPublishedVersions = async id => {
  const url = `${URL.BASE_URL}publishedmessage?messageId=${id}`;
  const response = await axiosCall('get', url);
  return response.data;
};

export const qaComplete = async (id, list) => {
  const url = `${URL.BASE_URL}qareadymessage/${list}/ready?id=${id}`;
  let response = await axiosCall('patch', url);
  return response.data;
};

export const publishTemplate = async (id, list) => {
  let li = list.join(',');
  const url = `${URL.BASE_URL}message/publish?messageId=${id}&messageType=${li}`;
  let response = await axiosCall('post', url);
  let finalResponse = response.data.statusCode;
  return finalResponse;
};

export const getAllPublishedMessages = async payload => {
  const params = new URLSearchParams(payload);
  const url = `${URL.BASE_URL}publishedmessage?${params}`;
  let response = await axiosCall('get', url);
  return response.data;
};

export const uploadMessagesDataSet = async (channel, payload) => {
  const url = `${URL.BASE_URL}live/uploadDataSet?channel=${channel}`;
  let response = await axiosCall('post', url, payload, true, false);
  return response.data;
};

export const changeTemplateName = async data => {
  const url = `${URL.BASE_URL}message?id=${data.id}&name=${data.name}`;
  let response = await axiosCall('patch', url, data);
  return response.data;
};

/////////////  Twilio Config ////////////

export const getTwilioConfig = async () => {
  const url = `${URL.BASE_URL}config/twilio`;
  let response = await axiosCall('get', url);
  return response.data;
};

export const updateChannelNum = async data => {
  const url = `${URL.BASE_URL}config/twilio`;
  let response = await axiosCall('patch', url, data);
  return response.data;
};

export const addTwilioConfig = async data => {
  const url = `${URL.BASE_URL}config/twilio`;
  let response = await axiosCall('post', url, data, false);
  return response.data;
};

export const updateTwilioConfig = async data => {
  const url = `${URL.BASE_URL}config/twilio`;
  const response = await axiosCall('put', url, data);
  return response.data;
};
